import styled from "styled-components";
import { WHEN_LG, WHEN_MD, WHEN_XL } from "../constants";

const Heading = styled.h1`
  margin: 0;
  margin-bottom: 0.5rem;
`;

export default Heading;
